import {
    BILLABLE,
    FREE_OF_CHARGE,
    ONLY_ME_ACCESS,
    ONLY_MEMBERS_ACCESS,
    PRIVATE_ACCESS,
    PUBLIC_ACCESS,
    RESTRICTED_ACCESS,
    STATE_ACTIVE,
    STATE_ARCHIVED,
    STATE_BLOCKED,
    STATE_CANCELLED,
    STATE_DELETED
} from "../../../actions/spaces";
import {TooltipIcon} from "../buttons/nav-buttons";
import {
    BlockedIcon,
    CancelIcon,
    CreditCardOffIcon,
    DoorClosedIcon,
    DoorOpenIcon,
    GlobeCancelIcon,
    GlobeIcon,
    GroupIcon,
    LocalAtmIcon,
    LockIcon,
    MembersOnlyIcon
} from "./nav-icons";
import React from "react";
import {useLanguage} from "../../configuration/configuration";
import {cn} from "../../util/text-utils";

const SpaceAccessIcon = ({access, verbose, className, ...otherProps}) => {
    const Lang = useLanguage();

    let icon; let text;
    switch (access) {
        case PUBLIC_ACCESS:
            text = Lang.access.public.text;
            icon = <TooltipIcon title={Lang.access.public.tooltip}>
                <GlobeIcon className={cn('clr-dark-gray', [className])} {...otherProps}/>
            </TooltipIcon>
            break;
        case PRIVATE_ACCESS:
            text = Lang.access.loggedInOnly.text;
            icon = <TooltipIcon title={Lang.access.loggedInOnly.tooltip}>
                <GlobeCancelIcon className={cn('clr-red', [className])} {...otherProps}/>
            </TooltipIcon>
            break;
        case RESTRICTED_ACCESS:
            text = Lang.access.friendsOnly.text('');
            icon = <TooltipIcon title={Lang.access.friendsOnly.tooltip}>
                <GroupIcon className={cn('clr-red', [className])} {...otherProps}/></TooltipIcon>
            break;
        case ONLY_ME_ACCESS:
            text = Lang.access.onlyMe.text;
            icon = <TooltipIcon title={Lang.access.onlyMe.tooltip}>
                <LockIcon className={cn('clr-red', [className])} {...otherProps}/></TooltipIcon>
            break;
        case ONLY_MEMBERS_ACCESS:
            text = Lang.access.onlyMembers.text;
            icon = <TooltipIcon title={Lang.access.onlyMembers.tooltip}>
                <MembersOnlyIcon className={cn('clr-red', [className])} {...otherProps}/></TooltipIcon>
            break;
    }

    // const {className, ...props} = otherProps;
    return <div {...otherProps}>
        {icon} {verbose && <span className='ml-1'>{text}</span>}
    </div>
}

// other props might be for ex. className='mr-2'
export const SpaceStateIcon = ({state, ...otherProps}) => {
    const Lang = useLanguage();

    let icon;
    switch (state) {
        case STATE_ACTIVE:
            icon = <TooltipIcon title={Lang.info.status.active}><DoorOpenIcon {...otherProps}/></TooltipIcon>
            break;
        case STATE_BLOCKED:
            icon = <TooltipIcon title={Lang.info.status.blocked}><BlockedIcon {...otherProps}/></TooltipIcon>
            break;
        case STATE_DELETED:
            icon = <TooltipIcon title={Lang.info.status.closed}><DoorClosedIcon {...otherProps}/></TooltipIcon>
            break;
        case STATE_ARCHIVED:
            icon = <TooltipIcon title={Lang.info.status.archived}><LockIcon {...otherProps}/></TooltipIcon>
            break;
        case STATE_CANCELLED:
            icon = <TooltipIcon title={Lang.info.status.cancelled}><CancelIcon {...otherProps}/></TooltipIcon>
            break;
        case 'NONE':
        case 'HIDDEN':
        case 'SHARED':
            icon = <TooltipIcon title={Lang.access.onlyMe.tooltip}><LockIcon {...otherProps}/></TooltipIcon>
    }

    return <span {...otherProps} >{icon}</span>
}

export const SpaceFeesIcon = ({fees, ...otherProps}) => {
    const Lang = useLanguage();

    let icon;
    switch (fees) {
        case BILLABLE:
            icon = <TooltipIcon title={Lang.info.fees.billable}><LocalAtmIcon {...otherProps}/></TooltipIcon>;
            break;
        case FREE_OF_CHARGE:
        default:
            icon = <TooltipIcon title={Lang.info.fees.free}><CreditCardOffIcon {...otherProps}/></TooltipIcon>;
            break;
    }

    return <span {...otherProps} >{icon}</span>
}

export default SpaceAccessIcon;